import httpRequest from '@/utils/api'

/**
 * 内容 Schema（匹配后端字段）
 */
export interface ContentSchema {
  id: number;
  text: string;
  contentType: number;
  languageId: number;
  ipaUk?: string;
  ipaUs?: string;
  translation?: string;
  hyphenation?: string;
  creatorId?: number;
  originalId?: string;
}

/**
 * 内容列表响应数据
 */
export interface ContentListResponseData {
  contents: ContentSchema[];
  total: number;
}

/**
 * 创建内容请求（使用 snake_case 发送到后端）
 */
export interface ContentCreateRequest {
  text: string;
  content_type: number;
  language_id: number;
  ipa_uk?: string;
  ipa_us?: string;
  translation?: string;
  hyphenation?: string;
  creator_id?: number;
}

/**
 * 更新内容请求（使用 snake_case 发送到后端）
 */
export interface ContentUpdateRequest {
  text?: string;
  content_type?: number;
  language_id?: number;
  ipa_uk?: string;
  ipa_us?: string;
  translation?: string;
  hyphenation?: string;
}

/**
 * API 路径枚举
 */
enum API {
  /** 内容列表 */
  contents = '/dictation-api/admin/dictation/contents',
  /** 单个内容 */
  content = '/dictation-api/admin/dictation/contents/:contentId',
}

/**
 * 获取内容列表
 * 
 * @param params - 查询参数
 * @returns 内容列表
 */
export const getContentListAPI = (params?: {
  page?: number;
  limit?: number;
  search?: string;
}) => {
  return httpRequest.get<ContentListResponseData>({
    url: API.contents,
    params,
  })
}

/**
 * 获取单个内容
 *
 * @param contentId - 内容 ID
 * @returns 内容详情
 */
export const getContentAPI = (contentId: number) => {
  return httpRequest.get<ContentSchema>({
    url: API.content.replace(':contentId', contentId.toString()),
  })
}

/**
 * 创建内容
 *
 * @param data - 创建请求数据
 * @returns 创建的内容
 */
export const createContentAPI = (data: ContentCreateRequest) => {
  return httpRequest.post<ContentSchema>({
    url: API.contents,
    data,
  })
}

/**
 * 更新内容
 *
 * @param contentId - 内容 ID
 * @param data - 更新请求数据
 * @returns 更新的内容
 */
export const updateContentAPI = (contentId: number, data: ContentUpdateRequest) => {
  return httpRequest.put<ContentSchema>({
    url: API.content.replace(':contentId', contentId.toString()),
    data,
  })
}

/**
 * 删除内容
 *
 * @param contentId - 内容 ID
 * @returns 删除结果
 */
export const deleteContentAPI = (contentId: number) => {
  return httpRequest.delete({
    url: API.content.replace(':contentId', contentId.toString()),
  })
}
